export const MENTORSHIP_CONTENT = [
  {
    menteeImage: "https://avatars1.githubusercontent.com/u/33068322?s=460&v=4",
    menteeName: "Mentee Name",
    menteeGithub: "",
    programName: "Codeuino Mentorship-CommunityBridge Mentorship 2020",
    projectName: "Lorem ipsum dolor sit amet consectetur adi",
    projectDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    projectLink: "",
  },
  {
    menteeImage: "https://avatars1.githubusercontent.com/u/33068322?s=460&v=4",
    menteeName: "Mentee Name",
    menteeGithub: "",
    programName: "Codeuino Mentorship-CommunityBridge Mentorship 2020",
    projectName: "Lorem ipsum dolor sit amet consectetur adi",
    projectDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    projectLink: "",
  },
];

export default MENTORSHIP_CONTENT;
